import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { OrdersService } from '../../services/orders/orders.service';
import { appService } from '../../../_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { Router } from '@angular/router';
import { Helpers } from '../../../helpers';

@Component({
  selector: 'app-cancel-eway-bill-modal',
  templateUrl: './cancel-eway-bill-modal.component.html',
  styleUrls: ['./cancel-eway-bill-modal.component.scss']
})
export class CancelEwayBillModalComponent implements OnInit,OnChanges {

  @Input() selectedId:any;
  @Input() cancelType:any;
  @Output() onCloseBtnClick = new EventEmitter<any>();
  @Output() onRefreshList = new EventEmitter<any>();
  CompanyId:any;

  Reason: any = {
    lable: 'Cancellation Reason',
    formControlName: 'Reason',
    dataField: 'Reason',
    isRequired: true,
    placeholder: 'Select Reason',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };

  cancelRemark = {
    lable: 'Cancel Remark',
    formControlName: 'cancelRemark',
    dataField: 'cancelRemark',
    isRequired: true,
    placeholder: 'Enter Remark',
  };

  ReasonValue:any;
  ReasonText:any;
  userId:any;
  cancelRemarkValue:any;
  CancelEwayBillApiData:any=[];

  constructor(
    private orderService: OrdersService,
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private router: Router
  ) { }

  ngOnInit() {
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedId'] && changes['selectedId'].currentValue) {
      this.GetCancelEwayBillApiData();
    }
  }

  getChangedValue(value, data){
    if(value){
      if(data.dataField === 'Reason'){
        this.ReasonValue = value.value;
        this.ReasonText = value.name;
      }else if (data.dataField === 'cancelRemark'){
        this.cancelRemarkValue = value;
      }
    } else {
      if(data.dataField === 'Reason'){
        this.ReasonValue = null;
        this.ReasonText = null;
      }else if (data.dataField === 'cancelRemark'){
        this.cancelRemarkValue = null;
      }
    }
  }

  GetReasonList(value, isScrollDown = false) {
    this.Reason.isSearch = true;
    let type = 'EWayBill Validity Reason';
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Reason.dropdownList.length / 20) + 1;
    }
    this.orderService.ReasonSelect2(value, pageNo, type).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.Reason.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Reason.dropdownList);
        this.Reason = { ...this.Reason, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Reason = { ...this.Reason, dropdownList: [...dropdownList] });
      this.Reason.isSearch = false;
    }).catch(error => {
      this.Reason.isSearch = false;
    })
  }

  Cancel() {
    this.onCloseBtnClick.emit()
  }

  GetCancelEwayBillApiData(){
    this._appService.GetById('so_GoodsOutward','GetCancelEwaybillData',this.selectedId).subscribe(
      (res)=>{
        if(res && res.length > 0){
          this.CancelEwayBillApiData = res;
        }else{
          this.CancelEwayBillApiData = [];
        }
        console.log('CancelEwayBillApiData',this.CancelEwayBillApiData);
      },
      (err)=>{
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }

  onSaveClick(){
    if (!this.ReasonValue) {
      this.toastr.warning('Please select a reason','Warning');
      return;
    }
    if (
      this.cancelRemarkValue === null ||  
      this.cancelRemarkValue === undefined ||
      this.cancelRemarkValue === ''
    ) {
      this.toastr.warning('Please enter remark','Warning');
      return;
    }
    
    const payload=[];
    var obj: any = {};
    const ele = this.CancelEwayBillApiData[0];
    obj.UserId = this.userId;
    obj.cndId = ele.cndId;
    obj.userGstin = ele.userGstin;
    obj.eway_bill_number = ele.eway_bill_number;
    obj.reason_of_cancel = this.ReasonText;
    obj.cancel_remark = this.cancelRemarkValue;
    obj.data_source = ele.data_source;
    payload.push(obj);
    
    Helpers.setLoading(true);
    this._appService.Post("BookingOrigin", "GenerateEWayBillCancel", payload).subscribe(
      (response) => {
        Helpers.setLoading(false);
        console.log(response);
        response.forEach((item) => {
          if (item.message == "EWayBill Canceled Successfully") {
            this.toastr.success("EWayBill Canceled Successfully!", "success");
            this.onRefreshList.emit('true');
            this.Cancel();
          }
          else {
            this.toastr.warning(item.message, "error");
          }
        });
      },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }

  // GenerateEWayBillCancel() {
  //     var flag: any = true;
  //     this.partBList = [];
  //     this.ConsignmentList.forEach((ele, index) => {
  //       if (!this.commonService.ValidateRequiredField($("#validityReason_" + index), "Please Select Reason", "after", "")) {
  //         flag = false;
  //       }
  //       if (!this.commonService.ValidateRequiredField($("#extendRemarks_" + index), "Please Enter Remark", "after", "")) {
  //         flag = false;
  //       }
  //       var obj: any = {};
  //       obj.UserId = this.UserId;
  //       obj.cndId = ele.cndId;
  //       obj.userGstin = ele.TransporterGST;
  //       obj.eway_bill_number = ele.eway_bill_number;
  //       obj.reason_of_cancel = ele.ValidityReason;
  //       obj.cancel_remark = ele.ExtendRemarks;
  //       obj.data_source = ele.data_source;
  //       this.partBList.push(obj);
  //     });
  //     if (flag) {
  //       Helpers.setLoading(true);
  //       this._appService.Post("BookingOrigin", "GenerateEWayBillCancel", this.partBList).subscribe(
  //         (response) => {
  //           Helpers.setLoading(false);
  //           console.log(response);
  //           response.forEach((item) => {
  //             if (item.message == "EWayBill Canceled Successfully") {
  //               this.toastr.success("EWayBill Canceled Successfully!", "success");
  //               this.onRefreshList.emit('true');
  //               this.Cancel();
  //             }
  //             else {
  //               this.toastr.warning(item.message, "error");
  //             }
  //           });
  //         },
  //         (err) => {
  //           Helpers.setLoading(true);
  //           this.toastr.error(err._body.replace(/"/g, ""), "error");
  //         }
  //       );
  //     } else {
  //       this.toastr.warning("Please fill required fields", "warning");
  //     }
  // }
}
